<template>
    <div class="section is-paddingless">
        <div class="columns">
            <div class="column is-one-quarter">
                <side-bar-filter></side-bar-filter>
            </div>
            <app-loader :loading="getLoaderStatus"
                        :color="options.color"
                        :size="options.size"
                        class="fixed-center">
            </app-loader>
            <div class="column" v-if="!getLoaderStatus">
                <favorite-searches></favorite-searches>
                <search-options></search-options>
                <select-models></select-models>
                <car-card v-for="(bid, index) in searchResults"
                          :bid="bid"
                          :key="index"></car-card>
                <div class="has-text-centered">
                    <button class="button is-large"
                            @click.prevent="loadMore()"
                            :disabled="isLastPage">
                        <span>Load More</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import appLoader from 'vue-spinner/src/ClipLoader'
    import carCard from '../../Card/LotLayout'
    import sideBarFilter from './SpecificationFilter.vue'
    import searchOptions from './SearchOptions.vue'
    import SelectModels from './SelectModels.vue'
    import FavoriteSearches from './FavoriteSearches'
    export default {
        components: {
            carCard,
            appLoader,
            sideBarFilter,
            searchOptions,
            SelectModels,
            FavoriteSearches
        },
        data() {
            return {
                options: this.$store.getters.getOptions
            }
        },
        computed: {
            getLoaderStatus() {
                return this.$store.getters.getLoaderStatus
            },
            searchResults() {
                return this.$store.getters.getSearchResults
            },
            isLastPage() {
                return this.$store.getters.isLastPage
            }
        },
        methods: {
            loadMore() {
                this.$store.dispatch('loadMoreResults')
            }
        },
        mounted() {
            this.$store.dispatch('fetchResults')
        }
    }
</script>

<style scoped>
    .section {
        padding-top: 30px!important;
    }
    .fixed-center {
        position: fixed;
        left: 50%;
        top: 35%;
    }
    .full-width {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Auctions/Results/SearchResult.vue